module.exports = __webpack_public_path__ + "static/media/Kanit-Medium.572f0aba.ttf";